const ShippingPolicy = () => {
  return (
    <div className="max-w-5xl mx-auto p-6  text-gray-800">
      <h1 className="sm:text-2xl text-3xl font-bold mb-6">
        Shipping & Delivery Policy
      </h1>

      <p className="mb-4">Effective Date: 20/04/2025</p>

      <p className="mb-4">
        At theZaik, each garment is a work of art—designed with precision,
        customized to your needs, and produced with a commitment to excellence.
        Due to the bespoke and bulk nature of our offerings, our shipping and
        delivery process is carefully structured to reflect the craftsmanship
        behind every order.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        1. Order Processing & Production Timeline
      </h2>

      <ul className="list-disc list-outside pl-4 mt-2">
        <li>
          All orders placed with theZaik are made-to-order, beginning production
          only after confirmation and customization approval.
        </li>
        <li>Production commences within 60 days of order placement.</li>
        <li>
          Total turnaround time—including production, quality control, and
          packaging—ranges between 90 to 120 days.
        </li>
        <li>
          This schedule ensures the highest quality and attention to detail in
          every piece.
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">2. Shipping Methods</h2>
      <div className="mb-4">
        <p>To ensure safe and reliable delivery, we ship using:</p>
        <ul className="list-disc list-outside pl-4 mt-2">
          <li>Cargo Services for bulk orders and high-volume shipments.</li>
          <li>India Post for smaller shipments and regional deliveries.</li>
          <li>Improve customer service and respond to inquiries</li>
          <li>
            Our logistics partners are selected for their reliability and
            coverage across India.
          </li>
        </ul>
        We do not use your data for marketing purposes unless explicitly
        consented.
      </div>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        3. Estimated Delivery Window
      </h2>
      <div className="mb-4">
        <p> From the date of order placement:</p>
        <ul className="list-disc list-outside pl-4 mt-2">
          <li>
            <strong>Minimum delivery time:</strong> 90 Days
          </li>
          <li>
            <strong>Maximum delivery time:</strong> 120 Days
          </li>
          <li>
            Please note that these timelines are inclusive of all stages:
            production, inspection, and shipping.
          </li>
        </ul>
      </div>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Shipping Charges</h2>
      <ul className="list-disc list-outside pl-4 mt-2">
        <li>
          Complimentary shipping is available on all orders above ₹1,00,000
          within India.
        </li>
        <li>
          For orders below this amount, standard shipping charges will apply and
          be displayed during checkout.
        </li>
        <li>
          Custom arrangements are available for corporate and bulk orders.
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">5. Order Tracking</h2>
      <p className="mb-4">
        Once your order has been dispatched, you will receive a tracking ID via
        email. You can monitor your shipment’s progress through our logistics
        partner’s website or reach out to our support team for real-time
        updates.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        6. Delays & Exceptions
      </h2>
      <p className="mb-4">
        While we are committed to timely delivery, occasional delays may occur
        due to:
        <ul className="list-disc list-outside pl-4 mt-2">
          <li>Fabric or material sourcing</li>

          <li>Customization complexities</li>

          <li>Regional disruptions or logistical issues</li>
          <li>
            In such cases, we will proactively communicate updated timelines.
          </li>
        </ul>
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">7. Need Help?</h2>
      <p className="mb-4">
        Our customer support team is here to assist you at every step of the
        way. For shipping or delivery inquiries, contact us at:
        <br />
        📧 Email: zaikcare@gmail.com
        <br />
        🌐 Website: www.zaik.com
      </p>
    </div>
  );
};

export default ShippingPolicy;
